import React from 'react';
import { 
  FaPaintBrush, 
  FaServer, 
  FaTools,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaBootstrap,
  FaSass,
  FaNodeJs,
  FaBolt,
  FaDatabase,
  FaFire,
  FaCode,
  FaGitAlt,
  FaGithub,
  FaTerminal,
  FaCloud,
  FaPenNib
} from 'react-icons/fa';

const skillsData = [
  {
    title: "Frontend Development",
    description: "Building beautiful, responsive user interfaces",
    icon: <FaPaintBrush />,
    tools: [
      { name: "HTML5", icon: <FaHtml5 /> },
      { name: "CSS3", icon: <FaCss3Alt /> },
      { name: "JavaScript", icon: <FaJs /> },
      { name: "React.js", icon: <FaReact /> },
      { name: "Bootstrap", icon: <FaBootstrap /> },
      { name: "Sass/SCSS", icon: <FaSass /> },
    ]
  },
  {
    title: "Backend Development",
    description: "Building robust server-side applications",
    icon: <FaServer />,
    tools: [
      { name: "Node.js", icon: <FaNodeJs /> },
      { name: "Express.js", icon: <FaBolt /> },
      { name: "MongoDB", icon: <FaDatabase /> },
      { name: "MySQL", icon: <FaDatabase /> },
      { name: "Firebase", icon: <FaFire /> },
      { name: "REST APIs", icon: <FaCode /> },
    ]
  },
  {
    title: "Tools & Others",
    description: "Design tools and development utilities",
    icon: <FaTools />,
    tools: [
      { name: "Git", icon: <FaGitAlt /> },
      { name: "GitHub", icon: <FaGithub /> },
      { name: "Figma", icon: <FaPaintBrush /> },
      { name: "Adobe XD", icon: <FaPenNib /> },
      { name: "VS Code", icon: <FaTerminal /> },
      { name: "Netlify", icon: <FaCloud /> },
    ]
  }
];

const Skills = () => {
  return (
    <section className="skills section-padding" id="skills">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">My <span>Skills</span></h2>
          <p className="section-subtitle">Technologies & Tools I work with</p>
          <div className="section-line"></div>
        </div>

        <div className="skills-grid">
          {skillsData.map((category, index) => (
            <div className="skill-category" key={index}>
              <div className="category-header">
                {category.icon}
                <h3>{category.title}</h3>
              </div>
              <p className="category-description">{category.description}</p>
              <div className="tools-grid">
                {category.tools.map((tool, toolIndex) => (
                  <div className="tool-item" key={toolIndex}>
                    <div className="tool-logo">
                      {tool.icon}
                    </div>
                    <span className="tool-name">{tool.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;